// component
import Iconify from "../../../components/iconify/Iconify";
import SvgColor from "../../../components/svg-color";
import customer from "../../../components/logo/rating.png";
import inward from "../../../components/logo/inbound (1).png";
import outward from "../../../components/logo/outbound.png";
import stockReport from "../../../components/logo/inventory.png";
import qualityReport from "../../../components/logo/quality.png";
import invoice from "../../../components/logo/invoiceIcon.png";
import purchaseInventory from "../../../components/logo/purchaseIcon.png";
import user from "../../../components/logo/programmer.png";
import dashboardIcon from "../../../components/logo/dashboardicon.png";
import vendor from "../../../components/logo/vendor.png";
import processdatasheet from '../../../components/logo/checklist.png';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfig = [
  {
    title: "dashboard",
    path: "/admin/app",
    // icon: <Iconify icon="ic:baseline-dashboard" />,
    icon: <img src={dashboardIcon} width="50%" />
  },
  {
    title: "All Users",
    path: "/admin/users",
    // icon: <Iconify icon="mingcute:user-add-fill" />,
    icon: <img src={user} width="50%" />
  },
  {
    title: "All Customers",
    path: "/admin/allcustomers",
    // icon: <Iconify icon="pepicons-pop:people" />,
    icon: <img src={customer} width="50%" />
  },
  {
    title: "All Vendors",
    path: "/admin/vendor",
    // icon: <Iconify icon="pepicons-pop:people" />,
    icon: <img src={vendor} width="50%" />
  },
  {
    title: "Delivery Challan",
    path: "/admin/challan",
    // icon: <Iconify icon="icon-park-twotone:express-delivery" />,
    icon: <img src={inward} width="50%" />
  },
  {
    title: "Outward List",
    path: "/admin/Outward",
    // icon: <Iconify icon="material-symbols:arrow-outward-rounded" />,
    icon: <img src={outward} width="50%" />
  },

  {
    title: "Stock Reports",
    path: "/admin/stockReport",
    // icon: <Iconify icon="bxs:report" />,
    icon: <img src={stockReport} width="47%" />
  },
  {
    title: "Quality Reports",
    path: "/admin/quality-report",
    // icon: <Iconify icon="icon-park-solid:sales-report" />,
    icon: <img src={qualityReport} width="47%" />
  },

  {
    title: "Invoices",
    path: "/admin/invoices",
    // icon: <Iconify icon="ph:invoice-fill" />,
    icon: <img src={invoice} width="47%" />
  },

  {
    title: "Purchase Inventory",
    path: "/admin/purchase_inventory",
    // icon: <Iconify icon="material-symbols-light:inventory" />,
    icon: <img src={purchaseInventory} width="50%" />
  },

  {
    title: "Process Data Sheet ",
    path: "/admin/process_sheet",
    // icon: <Iconify icon="material-symbols-light:inventory" />,
    icon: <img src={processdatasheet} width="50%" />
  },
];

export default navConfig;
